import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  background: ${({ theme }) => theme.backgroundColor};
  color: ${({ theme }) => theme.foregroundColor};
  border-radius: 24px;
  width: 350px;
  height: 350px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
  padding: 0;
  overflow: auto;
  z-index: 2;
`;
